export default __webpack_public_path__ + "static/media/1664.ad5a9ed4.png";